import Total from './Total'
export default Total
